import { createApi } from '@reduxjs/toolkit/query/react'
import {
  EquipmentHistory,
  EquipmentPayload,
  EquipmentResponse,
  EquipmentType,
} from './equipments.types'
import { createBaseQueryWithReauth } from 'store/auth/base-query-with-reauth'

const baseUrl = `${process.env.REACT_APP_ORDER_SERVICE_API}`

export const equipmentsApi = createApi({
  reducerPath: 'equipmentsApi',
  baseQuery: createBaseQueryWithReauth(baseUrl!),
  endpoints: (builder) => ({
    createEquipment: builder.mutation<EquipmentResponse, EquipmentPayload>({
      query: (body) => ({
        url: 'osapi/v1/equipments',
        method: 'POST',
        body,
      }),
    }),

    updateEquipment: builder.mutation<
      EquipmentResponse,
      { equipmentId: number } & EquipmentPayload
    >({
      query: ({ equipmentId, ...body }) => ({
        url: `osapi/v1/equipments/${equipmentId}`,
        method: 'PUT',
        body,
      }),
    }),

    listEquipments: builder.query<EquipmentResponse[], void>({
      query: () => ({
        url: 'osapi/v1/equipments',
        method: 'GET',
      }),
    }),

    deleteEquipment: builder.mutation<EquipmentResponse, string>({
      query: (id) => ({
        url: `osapi/v1/equipments/${id}`,
        method: 'DELETE',
      }),
    }),

    getEquipmentHistory: builder.query<
      EquipmentHistory[],
      { equipmentId: number; equipmentType: EquipmentType }
    >({
      query: ({ equipmentId, equipmentType }) => ({
        url: `osapi/v1/equipments/${equipmentId}/history`,
        method: 'GET',
        params: { equipmentType },
      }),
    }),
  }),
})

export const {
  useCreateEquipmentMutation,
  useUpdateEquipmentMutation,
  useListEquipmentsQuery,
  useLazyListEquipmentsQuery,
  useDeleteEquipmentMutation,
  useGetEquipmentHistoryQuery,
} = equipmentsApi
